import * as React from 'react'
import { StoreProps } from 'src/stores'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Link from 'src/components/atoms/input/buttons/Link'

interface Props extends StoreProps {
  location: any
  history: any
  match: any
  clever: any
}

@inject('confStore')
@observer
export class ThankYou extends React.Component<Props, any> {
  render() {
    const { confStore, match, history, clever } = this.props
    let urlRedirect = '/vollmacht'
    if (clever) {
      urlRedirect = '/clever/vollmacht'
    }
    if (!confStore.getMandateDownloadUrl()) {
      if (!confStore.isOfferLoaded && !!match.params.uuid) {
        confStore.findOfferByUuid(match.params.uuid)
        return (
          <Container>
            <h1 style={{ textAlign: 'center' }}>Lädt...</h1>
          </Container>
        )
      } else {
        const redirect =
          urlRedirect + (match.params.uuid ? '/' + match.params.uuid : '')
        history.push(redirect)
      }
    }
    if (clever) {
      // Thankyou content for Clever
      return (
        <Container>
          <h1>Vielen Dank</h1>
          <p>
            Ihre Vollmacht wurde erstellt und erfolgreich an das
            Kundenservice-Team von CLEVER Bestattungen übermittelt. Ihr
            persönlicher Ansprechpartner wird sich in Kürze bei Ihnen melden!
          </p>
          <p>
            Laden Sie sich hier gleich eine Kopie Ihrer Vollmacht für Ihre
            Unterlagen herunter:
          </p>
          <Link
            light={false}
            to={confStore.getMandateDownloadUrl()}
            target='_blank'
            clever={clever}>
            Vollmacht herunterladen
          </Link>
          <p>
            Bei Fragen sind wir jederzeit unter{' '}
            <a href='tel:+4319076885'>01 907 68 85</a> oder per E-Mail an{' '}
            <a href='mailto:kontakt@clever-bestattung.at'>
              kontakt@clever-bestattung.at
            </a>{' '}
            für Sie erreichbar.
          </p>
          <Link
            light={false}
            to='https://www.clever-bestattung.at/'
            target='_blank'
            clever={clever}>
            Zurück zu CLEVER
          </Link>
        </Container>
      )
    } else {
      return (
        <Container>
          <h1>Vielen Dank!</h1>
          <p>
            Ihre Vollmacht wurde erstellt und erfolgreich an das
            Kundenservice-Team von Benu Bestattungen übermittelt. Ihr
            persönlicher Ansprechpartner wird sich in Kürze bei Ihnen melden!
          </p>
          <p>
            Laden Sie sich hier gleich eine Kopie Ihrer Vollmacht für Ihre
            Unterlagen herunter:
          </p>
          <Link
            light
            to={confStore.getMandateDownloadUrl()}
            target='_blank'
            clever={clever}>
            Vollmacht herunterladen
          </Link>
          <p>
            Bei Fragen sind wir jederzeit unter{' '}
            <a href='tel:+4319076885'>01 907 68 85</a> oder per E-Mail an{' '}
            <a href='mailto:kontakt@benu.at'>kontakt@benu.at</a> für Sie
            erreichbar.
          </p>
          <Link light to='/' target='_self' clever={clever}>
            Zurück zu Benu
          </Link>
        </Container>
      )
    }
  }
}

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  min-height: 100vh;
  margin: auto;
  padding: 100px 35px;
  h1 {
    margin-bottom: 35px;
  }
`
export default withRouter(ThankYou)



// WEBPACK FOOTER //
// ./src/components/organisms/warrant/ThankYou.tsx